module.exports = __webpack_public_path__ + "img/logo.c4e721aa.png";